/*global angular */
'use strict';

angular.module('MrDWebApp').controller('PaymentReturnCtrl', function ($scope, $timeout, $rootScope, SEO, $cookies, storage, order, orderFactory, status, $state, $stateParams, $interval, $window) {

  var _prc = this;

  $scope._rc.bodyClass = 'html-payment-return';
  $scope.exceptionOrder = null;

  _prc.status = status;
  _prc.refreshing = false;
  _prc.timerStopped = false;
  _prc.goToTrackingButton = false;

  // Empty Cart Items
  $scope._rc.emptyCart();


  _prc.order = order;

  _prc.refresh = function () {
    _prc.refreshing = true;
    angular.extend(_prc.order, orderFactory.get({ userID: _prc.order.customer.id, orderID: _prc.order.id },
      function () {
        _prc.refreshing = false;
      }));
  };

  _prc.phase = -1;
  _prc.screen = 0;
  _prc.screen_delay = 0;
  

  _prc.startPolling = function () {

    _prc.waitingTimer = $interval(function () {
      _prc.phase += 1;

      _prc.loadingClass = 'stage-' + _prc.phase;
      if (_prc.phase === 8) {
        _prc.phase = -1;
        if (_prc.screen < 4) {
          _prc.screen += 1;
          $timeout(function () {
            _prc.screen_delay += 1;
          }, 1000);
        }
        orderFactory.get({
          userID: $stateParams.userID,
          orderID: $stateParams.orderID
        }, null, function success(response) {
          angular.extend(_prc.order, response);

          //if ($rootScope.v2) {

          angular.element(document.getElementById('html')).addClass('awaiting-' + _prc.screen);

          switch (_prc.order.status) {

            case 'restaurant_accepted':
            case 'delivery':
            case 'delivery_instruction_received':
            case 'en_route_to_collection':
            case 'at_restaurant':
            case 'en_route_to_delivery':
            case 'nearby':
            case 'doorbell':
            case 'delivered':

              /* Analytics */
              $scope._rc.trackOrderRestaurantAccepted();
              //$scope._rc.trackOrderEcommerce(); //MOVED OUTSIDE OF THE POLL

              $scope._rc.title_tag = 'Order Accepted!';

              if (_prc.order.type === 'collect') {
                $state.go('collection', { orderID: _prc.order.id, userID: _prc.order.customer.id });
              }
              if (_prc.order.type === 'delivery') {
                $state.go('tracking', { orderID: _prc.order.id, userID: _prc.order.customer.id });
              }

              break;
            case 'system_auto_rejected':
            case 'restaurant_auto_rejected':
            case 'restaurant_rejected':
            case 'cancelled':
            case 'failed_delivery_injection':
            case 'failed_restaurant_injection':
            case 'failed_delivery':
              /* Analytics */
              $scope._rc.trackexceptionOrder(_prc.order.status);
              _prc.stopTimer();
              //$state.go('exceptions', { orderID: _prc.order.id, userID: _prc.order.customer.id, statusID: _prc.order.status });

              // console.log("order of exception", order);
              $scope.exceptionOrder = response;
          }
        },
          function err() {
            /* Analytics */
            $scope._rc.trackexceptionOrder('error');
            
            //_prc.stopTimer(); //rather don't stop polling as subsecquent calls can still be perfectly fine
            
          });

      }
    }, 550);
  };

  _prc.stopTimer = function () {
    if (angular.isDefined(_prc.waitingTimer)) {
      $interval.cancel(_prc.waitingTimer);
      _prc.waitingTimer = undefined;
    }
    _prc.timerStopped = true;
  };

  $scope.$on('$destroy', function () {
    // Make sure that the interval is destroyed too
    _prc.stopTimer();
  });


  if(_prc.status === 'cancel'){ // Ipay failure..
    $rootScope.$broadcast('seo_update', { overwrite: { 
        title_tag: 'Cancelled Payment',
        description_tag: SEO.descriptionTag('default'),
        keywords_tag: SEO.keywordsTag('default')
    } });
    $rootScope.$broadcast('global_message:show',{
      'name': 'payment_cancel',
      'for_state': 'payment_return',
      'title': 'Payment Cancelled',
      'error' : {
        'friendly_message': 'There was a hitch in the payment procedure. Please retry with another method.'
      },
      'confirm' : {
        'label': 'Try Again',
        'action': 'redirect',
        'value': 'checkout',
        'value_object': $scope._rc.cart
      },
      'deny' : {
        'label': 'New Order',
        'action' : 'redirect',
        'value' : 'location',
        'value_object': $scope._rc.variables
      }
    });
  } else if(_prc.status === 'failure') { // Ipay failure..
    $rootScope.$broadcast('seo_update', { overwrite: { 
        title_tag: 'Failed Payment',
        description_tag: SEO.descriptionTag('default'),
        keywords_tag: SEO.keywordsTag('default')
    } });
    _prc.order.$promise.then(function (order) {
      var msg = order.payment.last_failed_reason;
      if (!msg) msg = 'There was a hitch in the payment procedure. Please retry with another method.';
      $rootScope.$broadcast('global_message:show',{
        'name': 'payment_cancel',
        'for_state': 'payment_return',
        'title': 'Payment Cancelled',
        'error' : {
          'friendly_message': msg
        },
        'confirm' : {
          'label': 'Try Again',
          'action': 'redirect',
          'value': 'checkout',
          'value_object': $scope._rc.cart
        },
        'deny' : {
          'label': 'New Order',
          'action' : 'redirect',
          'value' : 'location',
          'value_object': $scope._rc.variables
        }
      });
    });
  } else {

    if($scope._rc.cart.payment.type === 'instant_eft'){
      // Dont do this when cash, has already been done previous screen.
      var update = {
        status: 'user_confirmed_payment'
      };

      orderFactory.update({
        'userID': $scope._rc.access.user.id,
        'orderID': $scope._rc.cart.id
      }, update, function success(response) {

        angular.extend($scope._rc.cart, response);

        $scope._rc.trackOrderEcommerce();
        $window._adjustEvent('b00w9v'); //purchase
        if (!response.statistics.sum_no_of_orders){
          $window._adjustEvent('qukqp6'); //first_purchase
        }

        // Empty Cart Items... Again
        $scope._rc.emptyCart();

        $rootScope.$broadcast('cart:modified');

        storage.set('mrd-web-cart', $scope._rc.cart);

        _prc.startPolling();

      }, function (er) {
        if (er.data.error.error_code === 'INVALID_WORKFLOW') {
          //order race condition - 3rd party payment system updated the order status already
          $scope._rc.trackOrderEcommerce();
          $window._adjustEvent('b00w9v'); //purchase
          if (!$scope._rc.cart.statistics.sum_no_of_orders){
            $window._adjustEvent('qukqp6'); //first_purchase
          }
          _prc.startPolling();
          return;
        }
        console.warn('Order update error:', er);
      });
    } else {

      //For TRACKING
      _prc.order.$promise.then(function (order) {

        if ($scope._rc.cart.payment.type === 'ebucks' && order.payment.status !== 'paid') {
          _prc.order.$promise.then(function (order) {
            var msg = order.payment.last_failed_reason;
            if (!msg) msg = 'There was a hitch in the payment procedure. Please retry with another method.';
            $rootScope.$broadcast('global_message:show',{
              'name': 'payment_cancel',
              'for_state': 'payment_return',
              'title': 'eBucks Payment Failed',
              'error' : {
                'friendly_message': msg
              },
              'confirm' : {
                'label': 'Try Again',
                'action': 'redirect',
                'value': 'checkout',
                'value_object': $scope._rc.cart
              },
              'deny' : {
                'label': 'New Order',
                'action' : 'redirect',
                'value' : 'location',
                'value_object': $scope._rc.variables
              }
            });
          });
          return;
        }

        if (
          (
            order.restaurant.status === 'restaurant_accepted' &&
            order.status !== 'awaiting_feedback'
          ) ||
          order.status === 'delivery_instruction_received' ||
          order.status === 'en_route_to_collection' ||
          order.status === 'at_restaurant' ||
          order.status === 'en_route_to_delivery' ||
          order.status === 'nearby' ||
          order.status === 'doorbell' ||
          order.status === 'delivered'
        ) {

          $scope._rc.trackOrderEcommerce();
          $window._adjustEvent('b00w9v'); //purchase
          if (!order.statistics.sum_no_of_orders){
            $window._adjustEvent('qukqp6'); //first_purchase
          }
          
          if (order.type === 'collect') {
            $state.go('collection', { orderID: _prc.order.id, userID: _prc.order.customer.id });
          } else {
            $state.go('tracking', { orderID: _prc.order.id, userID: _prc.order.customer.id });

          }
        } else if (
          order.status === 'system_auto_rejected' ||
          order.status === 'restaurant_auto_rejected' ||
          order.status === 'restaurant_rejected' ||
          order.status === 'cancelled' ||
          order.status === 'failed_delivery_injection' ||
          order.status === 'failed_restaurant_injection' ||
          order.status === 'failed_delivery'
        ) {
          /* Analytics */
          $scope._rc.trackexceptionOrder(order.status);

          // console.log("order of exception", order);
          $scope.exceptionOrder = order;
        } else {

          $scope._rc.trackOrderEcommerce();
          $window._adjustEvent('b00w9v'); //purchase
          if (!order.statistics.sum_no_of_orders){
            $window._adjustEvent('qukqp6'); //first_purchase
          }
          
          _prc.startPolling();
        }
      });
    }
  }
 

  //console.log('status updated',$scope._rc.cart.status)
  
  

});
